import Counter from '../../components/counter';

type TProps = {
  fontColor?: string
}

const PageCounter = ({fontColor}: TProps) => {
  return (
    <Counter fontColor={fontColor} />
  )
}

export default PageCounter;